import {SensorModel} from './sensor-model';

export class PumpSensorModel extends SensorModel {
  sensorId: string;
  name: string;

  sensorType: number;
  minValue: number;

  index: number;
  value?: number;

  image?: string;

  pumpBrand: string;
  pumpType: string;
  pumpElectronicallyControlled: boolean;

  customName?: string;

  constructor() {
    super();
    this.sensorId = '';
    this.name = '';
    this.sensorType = null;
    this.minValue = 0.01;
    this.index = null;
    this.value = null;
    this.image = '';
    this.pumpBrand = '';
    this.pumpType = '';
    this.pumpElectronicallyControlled = false;
  }
}
